<template>
    <div class="info">
        <div class="info-desc">
            <div class="desc-content">
                <div class="contact">
                    <div class="b-title">
                        契合科技营销产品矩阵，新金融，新营销
                    </div>
                    <div class="s-title">
                        实施运营⼀条龙服务，让您省时省⼼做好数字化运营工作
                    </div>
                    <div class="contact-info">
                        <div class="contact-item">
                            <div class="item-txt">
                                <span class="tel"></span
                                ><span class="txt">公司电话：</span>
                            </div>
                            <div class="num">400-000-5560</div>
                        </div>
                        <div class="contact-item">
                            <div class="item-txt">
                                <span class="mail"></span
                                ><span class="txt">商务合作：</span>
                            </div>
                            <div class="num">service@qihe-cloud.com</div>
                        </div>
                    </div>
                </div>
                <div class="qrcode">
                    <img
                        src="../assets/code.png"
                        alt=""
                        class="qrcode-img"
                    />
                    <div class="qrcode-txt">体验私域流量运营</div>
                    <div class="qrcode-txt">完整解决方案</div>
                </div>
            </div>
        </div>
        <div class="btns" @click="denglu">
            <span class="btn-try">立即试用</span>
        </div>
        <div class="split-line"></div>
        <div class="copyright">
            Copyright  2019-2024 Qihe-Cloud 沈阳契合科技有限公司 版权所有:
            <!-- <a href="https://beian.miit.gov.cn/" class="copyrightaa">辽ICP备14018473号-2</a> -->
            <a href="https://beian.miit.gov.cn/" class="copyrightaa">辽ICP备14018473号-7</a>
            <!-- <a href="https://beian.miit.gov.cn/" class="copyrightaa">辽ICP备14018473号-1</a> -->
        </div>
        <!---->
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {};
    },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    methods: {
        nolond() {},
         denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../static/chunk-hdcrm.css";
.copyrightaa { 
    color: #666;
 }
</style>


// WEBPACK FOOTER //
// src/components/info.vue